import { ReactNode } from "react";
import PageNotFound from "../PageNotFound";
import Loading from "../Widgets/Loading";
import { Audience } from "./audience";
import { useAudience } from "./useAudience";
import { useCerberus } from "../../hooks/useCerberus";
import NoRolesAssigned from "./NoRolesAssigned";

/**
 * Restricts a route to one portal. Before the route trees were merged this was structural — a
 * patient had no /calendar route at all — and most clinical routes still carry only RequireAuth,
 * so without this wrapper the merged tree would hand them to anyone who is signed in.
 *
 * Denies with PageNotFound, matching what the wrong audience saw before the merge — except for a
 * signed-in account with no role at all, which is told why (see ByRole).
 */
const RequireAudience = ({
  audience,
  children,
}: {
  audience: Audience;
  children: ReactNode;
}) => {
  const { audience: current, loading } = useAudience();
  const { userId, roles } = useCerberus();

  if (loading) return <Loading />;
  if (userId && !roles?.length) return <NoRolesAssigned />;

  return current === audience ? children : <PageNotFound />;
};

export default RequireAudience;
